import React from "react";
import styles from "../ProductTagComp/ProductTagComp.module.scss";

// Define and export the ProductTagCompBadge functional component
// The following componenet will only be rendered on PDP
export default function ProductTagCompBadge(props) {    

    let pdpBadgeURL = ""; // Initialize the URL for the badge link

    // Determine the URL based on the value of props.cvalue
    switch (props?.cvalue) {
        case "New Arrival":
            pdpBadgeURL = `/new-arrivals`;
            break;
        case "Selling Fast":
            pdpBadgeURL = `/collection/all-bestsellers`;
            break;
        case "New Brand":
            pdpBadgeURL = `/designer/${props?.brand}`;
            break;
        case "Conscious":
            pdpBadgeURL = `/collection/the-conscious-edit`;
            break;
        case "15% off Jewelry":
            pdpBadgeURL = `/jewelry-watches`;
            break;
        default:
            pdpBadgeURL = "";
            break;
    }
    if (props.cvalue) {
        // Check if the tag is a promo tag
        const isPromo = props.cvalue === "15% off Jewelry";
        return (
            <>
                {pdpBadgeURL.length > 0 ? (<a className={`${styles.product_badge} ${props.cname} ga-pdp-badge ${isPromo && `promo-badge`}`} href={pdpBadgeURL} ga4data={props.cvalue}>{props.cvalue}</a>) : (<div className={`${styles.product_badge} ${props.cname} ${isPromo && `promo-badge`}`}>{props.cvalue}</div>)}
            </>
        );
    }

}
